<template>
  <div id="user">
    <div class="header-div">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="header-div" style="text-align: right">
      <div style="float: right">
        <el-button size="mini" v-if="$hasPerm('common:dict:add')" @click="handleAdd()" style="background-color:#16E3A1;color: white;">新增<i class="el-icon-plus"></i></el-button>
      </div>
      <div style="float: right">
        <el-button size="mini" style=";background-color:#409EFF;color: white;">查询<i class="el-icon-search"></i></el-button>
      </div>
      <div style="float: right">
        <el-select v-model="typeValue" size="mini" class="dicListSelectCss" @change="selectFun" filterable placeholder="请选择字典类型">
          <el-option
            v-for="item in selectType"
            :key="item.type"
            :label="item.description"
            :value="item.type">
          </el-option>
        </el-select>
      </div>
    </div>
    <el-table
    :data="tableData"
    style="width: 100%;margin-bottom: 5px;"
    height="429"
    size="medium"
    row-key="id"
    border
    :tree-props="{children: 'children'}"
    >
      <el-table-column prop="description" label="类型名称" style="width: 16.66666666%"></el-table-column>
      <el-table-column prop="type" label="字典类型" style="width: 16.66666666%"></el-table-column>
      <el-table-column prop="value" label="字典值" style="width: 16.66666666%"></el-table-column>
      <el-table-column prop="sort" label="排序" style="width: 16.66666666%"></el-table-column>
      <el-table-column label="操作" v-if="$hasPerm('common:dict:edit,common:dict:remove')">
        <template slot-scope="scope">
          <el-button v-if="$hasPerm('common:dict:edit')" size="mini" style="margin-right: 5px;" @click="handleEdit(scope.$index, scope.row)">编辑<i class="el-icon-edit"></i></el-button>
          <el-popconfirm v-if="$hasPerm('common:dict:remove')" title="确定删除吗？" @onConfirm="handleDelete(scope.$index, scope.row)">
            <el-button size="mini" slot="reference" type="danger">删除<i class="el-icon-delete"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!--<el-pagination
    background
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
    :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
    :page-size="pageSize"
    :current-page="currentPage"
    @current-change="handleCurrentChange"
    @size-change="handleSizeChange"
    ></el-pagination>-->
    <edit v-if="editVisible" ref="edit" @handleRefresh="handleRefresh"></edit>
  </div>
</template>
<script>
    import Edit from './edit'
    export default {
      name: 'DicList',
      components:{
        Edit
      },
      data() {
        return {
          currentPage: 1, //初始页
          pageSize: 10, //    每页的数据
          total: 0,
          offset: 0,
          tableData: [],
          selectType:[],
          typeValue:'',
          editVisible: false
        }
      },
      methods: {
        handleCurrentChange(cPage) {
          this.offset = (cPage-1)*this.pageSize;

          this.$httpTAG({
            url: this.$httpTAG.adornUrl('/common/dict/list'),
            method: 'get',
            params: this.$httpTAG.adornParams({
              'type': this.typeValue
            })
          }).then(r => {
            this.tableData = r.data.data;
            this.total = r.data.data.total;
          }).finally(r => {})

        },
        handleSizeChange(val) {
          this.pageSize = val;
          this.handleCurrentChange(1);
        },
        selectFun() {
          this.handleCurrentChange(1);
        },
        handleRefresh() {
          this.inItType();
          this.handleCurrentChange(1);
        },
        inItType() {

          this.$httpTAG({
            url: this.$httpTAG.adornUrl('/common/dict/type'),
            method: 'post'
          }).then(r => {
            this.selectType = r.data.data;
            if(this.selectType.length>0 && this.typeValue==''){
              this.typeValue = this.selectType[0].type;
            }
            this.handleCurrentChange(this.currentPage);
          }).finally(r => {})

        },
        handleEdit(index, row) {
          this.editVisible = true;
          this.$nextTick(()=>{
            this.$refs.edit.int(row.id,null,null);
          })
        },
        handleAdd() {
          this.editVisible = true;
          this.$nextTick(()=>{
            //获取字典类型描述
            let obj = this.selectType.find((item)=>{
              return item.type === this.typeValue;
            });
            let ms = "";
            if(obj!=null){
              ms = obj.description;
            }
            this.$refs.edit.int('add',this.typeValue,ms);
          })
        },
        handleDelete(index, row) {
          let id = row.id;

          this.$httpTAG({
            url: this.$httpTAG.adornUrl('/common/dict/remove'),
            method: 'post',
            data: this.$httpTAG.adornData({
              'id': id
            })
          }).then(res => {
            if (res.data.code == 0) {
              this.$notify({
                title: '操作成功！',
                type: 'success',
                offset: 600
              });
              this.handleCurrentChange(1);
            } else {
              this.$message({ // 失败
                type: 'error',
                message: res.data.msg
              })
            }
          }).finally(r => {})

        }
      },
      created: function() {
        this.inItType();
      }
    }
</script>
<style scoped>
  .header-div{
    margin-bottom: 5px;
    float: left;
    width: 50%;
  }
  .dicListSelectCss >>> .el-input__inner{
    height: 28px;
    border-radius: 0px;
    width: 256px;
  }

</style>
